// extracted by mini-css-extract-plugin
export default {"location":"userCardSmartTooltip_location__OGIG5","locationTooltip":"userCardSmartTooltip_locationTooltip__uUWDh","emptyLocation":"userCardSmartTooltip_emptyLocation__kQ3+D"};